import { VALIDATION_REGEX } from '../validators/validationRegex';

export const healPhoneNumberValue = (phoneNumber: string) => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  if (!VALIDATION_REGEX.usaPhone.test(phoneNumber)) {
    return phoneNumber;
  }

  return phoneNumber.replace(/\D/g, '');
};
